import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const usCustomStyles = makeStyles()((theme) => ({
	wrapper: {
		display: 'grid',
		width: '100%',
		gridColumnGap: theme.spacing.xxsmall,
		gridRowGap: theme.spacing.xsmall,
		gridTemplateColumns: 'repeat(2, 1fr)',
		[getFromBreakpoint('lg')]: {
			gridTemplateColumns: 'repeat(3, 1fr)',
		},
	},
	title: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	ratingContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		marginBottom: theme.spacing.small,
		flexDirection: 'column',
		gap: theme.spacing.xxsmall,

		[getFromBreakpoint('sm')]: {
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'start',
			gap: theme.spacing.medium,
		},
	},
	ratingButton: {
		[getFromBreakpoint('lg')]: {
			marginLeft: 'auto',
		},
	},
	ratingBox: {
		overflow: 'hidden',
	},
	noReviewContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'start',
		gap: theme.spacing.small,
		border: theme.divider.border,
		padding: theme.spacing.small,
		boxShadow: theme.elevation.top.lifted,
		borderRadius: theme.borderRadius.rounded,

		[getFromBreakpoint('lg')]: {
			flexDirection: 'row',
			alignItems: 'center',
			gap: theme.spacing.xsmall,
		},
	},
}));
